import { Holiday } from './holiday';
import { ShiftType } from './shift-type';
export class Shift {
  date: Date = null;
  id = '';
  status = '';
  shiftType: ShiftType;
  holiday: Holiday = new Holiday();
}



// WEBPACK FOOTER //
// /opt/build/repo/src/app/models/shift.ts